<template>
  <div class="table-action-wrapper design-assign" ref="container">
    <div class="position-relative d-flex w-100">
      <Select source="template/search" field="manufacture" placeholder="Template" v-model="templateId" class="flex-1 mr-2"></Select>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center">
        <span>Confirm</span>
      </a>
    </div>
  </div>
</template>
<script>
import { utils, writeFileXLSX } from 'xlsx'
export default {
  data() {
    return {
      templateId: null
    }
  },
  computed: {
    store() {
      return this.config?.store
    },
    query() {
      return this.store.getter('query', {})
    }
  },
  methods: {
    exportToXlsx(data) {
      let workbook = utils.book_new()
      Object.entries(data).forEach(([, sheet]) => {
        let data = [
          sheet.columns.map((item) => {
            return item.title
          })
        ]
        let worksheet = utils.aoa_to_sheet(data.concat(sheet.data))
        utils.book_append_sheet(workbook, worksheet, sheet.name)
      })
      writeFileXLSX(workbook, `File-${new Date().getTime()}.xlsx`)
    },
    async submit() {
      let query = Object.assign(
        _.reduce(
          this.query,
          (result, item, key) => {
            let value = _.isObjectLike(item) ? item?.value : item
            if (value) {
              result[key] = value
            }
            return result
          },
          {}
        ),
        {
          type: 'manufacture',
          template_id: this.templateId
        }
      )

      let response = null
      let page = 0
      let data = {}
      do {
        page += 1
        query.page = page
        response = await this.$util.get('template/export/manufacture', query, this.$refs.container)
        if (response.status == 'success') {
          if (Object.keys(data.items || []).length == 0) {
            data = response.data
          } else {
            data.items = data.items.concat(response.data.items)
          }
        }
      } while (response?.data?.items?.length == 100)
      if (data.items.length > 0) {
        this.exportManufacture(Object.values(data.template.meta.data || []), Object.values(data.items))
      }
    },
    exportManufacture(columns, items) {
      let colIndexs = []
      columns.forEach((colVal, colKey) => {
        colVal = Object.assign(
          {
            field: ''
          },
          colVal
        )
        if (colVal.field.toLowerCase().replace(/\s*/g, '') == 'line_item>attributes') {
          colIndexs.push(colKey)
        } else {
          columns[colKey].field = colVal.field.toLowerCase().replace(/\s*/g, '')
        }
      })

      let attributes = {}
      items.forEach((item) => {
        Object.entries(item).forEach(([key, value]) => {
          if (key.toLowerCase().replace(/\s*/g, '') == 'line_item>attributes' && value) {
            let combinedAttribute = []
            Object.entries(value).forEach(([attributeKey, attribute]) => {
              let attrKeyLower = attributeKey.toLowerCase().replace(/\s*/g, '')
              if (attributes[attrKeyLower] == undefined) {
                attributes[attrKeyLower] = {
                  title: attributeKey,
                  field: `line_item>attributes>${attrKeyLower}`
                }
              }
              combinedAttribute.push(`${attributeKey}:\n${attribute}`)
              item[`line_item>attributes>${attrKeyLower}`] = attribute
            })
            item['combined_attribute'] = combinedAttribute.join("\n")
          } else {
            item[key.toLowerCase().replace(/\s*/g, '')] = value
          }
        })
      })

      if (colIndexs.length > 0) {
        colIndexs.sort(function (a, b) {
          return b - a
        })
        colIndexs.forEach((colIndex) => {
          columns.splice(colIndex, 1)
          columns.splice(colIndex, 0, ...Object.values(attributes))
        })
      }

      let sheet = {
        name: 'Sheet 1',
        columns: columns,
        data: []
      }

      items.forEach((item) => {
        let rows = [[]]
        Object.entries(item).forEach(([k, v]) => {
          item[k.toLowerCase().replace(/\s*/g, '')] = v
        })
        columns.forEach((column) => {
          column = Object.assign(
            {
              field: ''
            },
            column
          )
          rows[0].push(item[column.field.toLowerCase().replace(/\s*/g, '')] || '')
        })
        sheet.data = sheet.data.concat(rows)
      })
      this.exportToXlsx([sheet])
    }
  },
  props: {
    config: Object
  }
}
</script>
